import { ID, SectionInsights } from '@griply/types';

export const toggleHiddenInsightsItem = (
  currentSection: SectionInsights | null | undefined,
  id: ID,
): SectionInsights => {
  const hiddenItems = currentSection?.hiddenItems ?? [];
  const extraItems = currentSection?.extraItems ?? [];
  const order = currentSection?.order ?? [];

  if (hiddenItems.includes(id) || extraItems.includes(id)) {
    return {
      hiddenItems: hiddenItems.filter((item) => item !== id),
      extraItems: extraItems.filter((item) => item !== id),
      order,
    };
  }

  return {
    hiddenItems: [...hiddenItems, id],
    extraItems,
    order,
  };
};
